import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import {
    Container,
    Box,
    Link
} from '@chakra-ui/react';

export default function Advertisement({ slice }) {
    console.log(slice)
    return (
       <Container maxW="container.xl" my="12">
            <Box display={{base: 'none', md: 'block'}}>
                <Link href={slice.primary.ad_link.url} target="_blank" rel="noopener noreferrer">
                    <GatsbyImage image={getImage(slice.primary.desktop_ad_image.localFile)} alt={slice.primary.desktop_ad_image.alt}/>
                </Link>
            </Box>
            <Box display={{base: 'block', md: 'none'}}>
                <Link href={slice.primary.ad_link.url} target="_blank" rel="noopener noreferrer">
                    <GatsbyImage image={getImage(slice.primary.mobile_ad_image.localFile)} alt={slice.primary.mobile_ad_image.alt}/>
                </Link>
            </Box>
       </Container>
    )
}